import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['image', 'skeleton'];

  connect() {
    if (!this.hasImageTarget) return;

    const img = this.imageTarget;

    if (img.complete && img.naturalHeight > 0) {
      this.hideSkeleton();
    } else {
      // Events are bound in JS rather than via a Stimulus action to keep
      // the template DSL simple — otherwise every <img>, including those
      // generated by display_picture, would need a data-action attribute.
      this.onLoad = () => this.hideSkeleton();
      this.onError = () => this.hideSkeleton();
      img.addEventListener('load', this.onLoad, { once: true });
      img.addEventListener('error', this.onError, { once: true });
    }
  }

  disconnect() {
    if (!this.hasImageTarget) return;

    const img = this.imageTarget;
    if (this.onLoad) img.removeEventListener('load', this.onLoad);
    if (this.onError) img.removeEventListener('error', this.onError);
  }

  hideSkeleton() {
    if (this.hasSkeletonTarget) {
      this.skeletonTarget.classList.add('d-none');
    }
    if (this.hasImageTarget) {
      this.imageTarget.classList.remove('invisible');
    }
  }
}
